import Vue from 'vue'

const API_AUTH_LOGIN = '/auth/token/issue'

export default (credentials) => {
  return Vue.http.post(API_AUTH_LOGIN, credentials)
}



// WEBPACK FOOTER //
// ./src/api/auth/login.js